// extracted by mini-css-extract-plugin
export default {"container":"faq_container__uDRfP"};